<script>
	import {onMount} from 'svelte'
	import {getContext} from 'svelte'
	import {API,http_headers,SPINNER} from '../global.js'
	export let cobranza
	export let formapago

	let fd = {}

	let cotizacion = 1.00

	let idejecutivo = getContext('eje')

	$: refresh = async () => {

		// datos del cliente
		let query = `select usuario,nombre,telefono,email from Telefonia.dbo.usuarios where idgescom=
(select idejecutivo from clientes where idcliente = ${cobranza.idcliente})`
		const res = await fetch(`${API}/exec-query`,
			{
				method:'POST',
				headers: http_headers,
				body:JSON.stringify({query})	
			})
		const data = await res.json()
		
		if(res.ok) return data.data[0]
		else throw new Error(data)
	
		/*
		let rs = await fetch(`${API}/clientes-by-id/${cliente}`)
		let ds = await rs.json()
		console.log(ds.data)
		return ds.data

		if(ds.success && ds.count){
			data = { info: ds.data[0], contactos : ds.contactos, domicilios : ds.domicilios }
		}
		//

		let rs = await fetch(`${API}/info-ejecutivo/${idejecutivo}`)
		let ds = await rs.json()
		return ds.data
		*/
	}

	onMount( async() => {
		fd.moneda=cobranza.idmoneda*1
		fd.simbolo = cobranza.simbolo+''

		if(formapago.cotizado!==1 && cobranza.idmoneda!==1 && formapago.cotizado!==cobranza.idmoneda){
			let rs = await fetch(`${API}/cotizacion/${formapago.cotizado}`)
			let ds = await rs.json()

			cotizacion = ds.data.Cotizacion
			//console.log(cotizacion)
			fd.moneda = 1
			fd.simbolo = '$'
			fd.conversion = cotizacion*1
		}
		fd.importe = (cobranza.importe*cotizacion).toFixed(2)


		

	})

	//console.log(cobranza)
</script>
<div class="container">
	{#await refresh()}
		<p>Loading....</p>
	{:then ejecutivo}
		{#if cobranza.idmoneda===1}
			<h3>{formapago.fpagoname}</h3>
			<h4>Total a depositar {fd.simbolo} {(parseFloat(cobranza.importe)*parseFloat(formapago.coef1val)).toFixed(2)}</h4>
			{@html formapago.observ}
		{/if}

		{#if cobranza.idmoneda===2}
			<h3>{formapago.fpagoname}</h3>
			<h4>Total a depositar {fd.simbolo} {(parseFloat(cobranza.importe)*parseFloat(cotizacion)*parseFloat(formapago.coef1val)).toFixed(2)}</h4>
			<br>
			<p>{@html formapago.observ} {ejecutivo.nombre} al telefono {ejecutivo.telefono} o por mail a <b>{ejecutivo.email}</b></p>
			<br>
		{/if}
		<p><small>(*) Luego de realizar la transferencia/deposito envie constancia a <b>{(ejecutivo.email||'<No tiene ejecutivo>').trim()}</b>, indicando su <span class="text-danger">numero de cliente</span></small></p>
	{/await}
</div>